import React from 'react';
import cls from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import { FieldErrors, FieldValues } from 'react-hook-form';

import styles from './index.module.sass';

interface FormErrorsProps<T extends FieldValues> {
  className?: string;
  defaultMessage?: string;
  errorString?: string;
  hookFormErrors?: FieldErrors<T>;
}

export const FormErrors = <T extends Object>({
  className,
  defaultMessage = 'Please correct invalid information.',
  errorString,
  hookFormErrors,
}: FormErrorsProps<T> ) => {
  if ( !errorString && Object.keys( hookFormErrors ?? {}).length === 0 ) return null;

  return (
    <div className={cls( styles.container, className )}>
      <FontAwesomeIcon className={styles.exclamation} icon={faExclamationTriangle} />

      <div className={cls( styles.errors, 'spec__form-errors' )}>
        {Object.keys( hookFormErrors ?? {})
          .reduce(( messages, error ) => {
            if ( messages.indexOf( hookFormErrors[error as keyof T].message ) === -1 ) {
              return [ ...messages, hookFormErrors[error as keyof T].message ];
            }
            return messages;
          }, [])
          .map(( message ) => (
            <span key={message || defaultMessage}>{`${message || defaultMessage} `}</span>
          ))}

        {errorString && <span>{`${errorString} `}</span>}
      </div>
    </div>
  );
};
